<template>
  <div>
    <comment-header
      v-if="visibleFlag == 1"
      :fathertitle="fathertitle"
      :childtitle="childtitle"
      :path="path"
    >
    </comment-header>

    <a-card
      v-if="visibleFlag == 1"
      style="margin-top: 24px"
      :bordered="false"
      title="任务列表"
    >
      <div slot="extra">
        <a-radio-group v-model="queryParam1.status">
          <a-radio-button value="-1" @click="loadTask2(-1)"
            >全部</a-radio-button
          >
          <a-radio-button value="0" @click="loadTask2(0)"
            >待测试</a-radio-button
          >
          <a-radio-button value="4" @click="loadTask2(4)"
            >等待处理</a-radio-button
          >
          <a-radio-button value="1" @click="loadTask2(1)"
            >正在测试</a-radio-button
          >
          <a-radio-button value="2" @click="loadTask2(2)">中断</a-radio-button>
          <a-radio-button value="3" @click="loadTask2(3)">完成</a-radio-button>
        </a-radio-group>
        <a-select
          placeholder="请选择项目"
          v-model="queryParam1.projectId"
          @select="selectProject"
          default-value="0"
          style="margin-left: 16px; width: 200px"
          show-search
          :filter-option="projectFilterOption"
        >
          <a-select-option value="0" key="0">全部项目</a-select-option>
          <a-select-option v-for="p in projectList" :key="p.id">
            {{ p.name }}
          </a-select-option>
        </a-select>
      </div>

      <div class="operate">
        <a-button type="dashed" style="width: 100%" icon="plus" @click="add"
          >添加</a-button
        >
      </div>

      <a-table
        size="large"
        :data-source="data"
        :columns="columns"
        :pagination="{
          pageSize: 10,
          total: paging.totalRecords,
          current: paging.pageIndex,
          onChange: onChangepage,
        }"
      >
        <a-table
          slot="expandedRowRender"
          slot-scope="text, record"
          :columns="innerColumns"
          :data-source="buildInnerText(text)"
          :pagination="false"
        >
        </a-table>
        <div slot="status" slot-scope="text, record" class="status">
          <div v-if="text == 0">待测试</div>
          <div v-if="text == 1">测试中</div>
          <div v-if="text == 2">
            中断
            <a-icon
              @click="errorMsg(record)"
              style="color: red; cursor: pointer"
              type="exclamation-circle"
            />
          </div>
          <div v-if="text == 3">完成</div>
          <div v-if="text == 4">等待处理</div>
          <div v-if="text == 42">等待中断处理</div>
        </div>
        <div slot="progress" slot-scope="text, record">
          <div v-if="record.status == 1 || record.status == 2">
            <a-progress :percent="record.progress.value" style="width: 180px" />
          </div>
        </div>
        <div slot="action" slot-scope="text, record">
          <!-- <a-button v-if="record.status == 3" @click="check(record)">
            查看测试结果集
          </a-button> -->
          <a-button
            v-if="
              record.status == 0 || record.status == 2 || record.status == 3
            "
            disabled="true"
            @click="start(record)"
          >
            <a-icon type="play-circle" />
            开始测试
          </a-button>
        </div>
        <div slot="actions" slot-scope="text, record">
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item @click="edit(record)"><a>编辑</a></a-menu-item>
              <a-menu-item @click="remove(record)"><a>删除</a></a-menu-item>
              <a-menu-item
                v-if="record.status == 3"
                @click="lookTestResult(record)"
                ><a>查看测试结果集</a></a-menu-item
              >
            </a-menu>
            <a-button>更多<a-icon type="down" /></a-button>
          </a-dropdown>
        </div>
      </a-table>
      <train-config
        ref="trainConfig"
        @cancel="handleCancel"
        @ok="handleOk"
        :title="title"
        :visible="visible"
        :loading="confirmLoading"
        :model="mdl"
        :showNetworkModelType="showNetworkModelType"
        :networkModelTypeList="networkModelTypeList"
        :resourceList="resourceList"
      >
      </train-config>

      <train-log
        ref="trainLog"
        @isopen="isopen"
        @cancel="handleCancel2"
        :title="title2"
        :visible="visible2"
        :loading="confirmLoading2"
        :ldata="logData"
      >
      </train-log>
      <add-task
        ref="addtask"
        @ok="addtask"
        @cancel="cancelAdd"
        :visible="showAddTask"
        :data="addtaskData"
        :projectList="projectList"
        @selectTestProject="selectTestProject"
        @changepage="changeAddpage"
        :pagination="addpagination"
      >
      </add-task>
      <edit-task
        ref="edittask"
        @ok="edittask"
        @cancel="canceledit"
        :visible="showEditTask"
        :edittaskdata="edittaskdata"
        :editdata="editdata"
        :editId="editId"
      >
      </edit-task>
    </a-card>
    <a-card v-else style="margin-top: -20px" :bordered="false" title="测试结果">
      <div class="operate">
        <a-button
          type="primary"
          style="margin-bottom: 20px"
          icon="left-outlined"
          @click="back()"
          >返回</a-button
        >
      </div>
      <div v-if="showType == 1">
        <a-row type="flex" :gutter="[16, 16]">
          <a-col :xs="{ span: 1, offset: 1 }" :lg="{ span: 1, offset: 0 }">
            <a-button type="primary" @click="download()"> 下载资源图 </a-button>
          </a-col>
          <a-col :xs="{ span: 1, offset: 1 }" :lg="{ span: 1, offset: 2 }">
            <a-button type="primary" @click="download2()">
              下载结果图
            </a-button>
          </a-col>
          <a-col :xs="{ span: 1, offset: 1 }" :lg="{ span: 1, offset: 2 }">
            <a-button type="primary" @click="scale('zoomIn')"> 放大 </a-button>
          </a-col>
          <a-col :xs="{ span: 1, offset: 1 }" :lg="{ span: 2, offset: 1 }">
            <a-button type="primary" @click="scale('zoomOut')"> 缩小 </a-button>
          </a-col>
          <a-col :xs="{ span: 2, offset: 1 }" :lg="{ span: 6, offset: 2 }">
            下载时同步删除测试资源库资源
            <a-switch
              checked-children="开"
              un-checked-children="关"
              v-model:checked="delFlag"
            />
          </a-col>
          <a-col>
            <span>
              面积：{{ divisionParams.area }} &nbsp;长度：{{
                divisionParams.width
              }}&nbsp;高度：{{ divisionParams.height }}&nbsp;灰度：{{
                divisionParams.gray
              }}
            </span>
          </a-col>
        </a-row>

        <a-row :gutter="[16, 16]" type="flex" align="middle">
          <a-col :span="24">
            <a-input-search
              style="margin-left: 250px; margin-bottom: 20px"
              placeholder="请输入文件名"
              v-model="searchFileName"
              @search="search"
            />
          </a-col>
        </a-row>
        <a-row>
          <div class="maxbox">
            <a-spin :spinning="imgLoading">
              <div id="bigbox">
                <div id="tagInBox">
                  <img :src="imgUrl" alt="" ref="img" class="canvas-img" />

                  <canvas
                    id="mycanvas"
                    ref="mycanvas"
                    width="1300"
                    height="500"
                    @mousedown="canvasDown"
                    @mousemove="canvasMove"
                    @mouseup="canvasUp"
                  >
                  </canvas>
                </div>
              </div>
            </a-spin>
            <div style="display: flex">
              <div class="box2">
                <a-button title="上一页" @click.native="toUp">
                  <a-icon type="up" />
                </a-button>
                <a-spin :spinning="listLoading">
                  <div class="imgList">
                    <div
                      :class="[
                        'minimgbox',
                        { borderColor: borderColor == index },
                      ]"
                      v-for="(item, index) in resultFileData"
                      :key="item.fileName"
                      @click="handlerImg(item, index)"
                    >
                      <img
                        :src="buildFilePath(item)"
                        class="minimg"
                        style="width: fit-content; height: 100%"
                        ref="minimg"
                        @load="imgLoad(index)"
                      />
                    </div>
                  </div>
                </a-spin>
                <a-button title="下一页" @click.native="toNext">
                  <a-icon type="down" />
                </a-button>
              </div>
            </div>
          </div>
        </a-row>
        <div class="imgtext">
          {{ imgText }}
        </div>
        <div class="show-page-list">
          <div>
            第{{ resultPagition.currentRecordIndex }}项/共{{
              resultPagition.totalRecords
            }}项 - 第{{ resultPagition.pageIndex }}页/共{{
              resultPagition.totalPages
            }}页
          </div>
          <div>
            跳至
            <a-input-number
              id="searchPage"
              size="small"
              :min="1"
              :step="1"
              :max="resultPagition.totalPages"
              v-model="searchPage"
              @change="currentPageChange"
              style="width: 55px; height: 25px; line-height: 15px"
            />
            页
          </div>
        </div>
      </div>
      <div v-else>
        <a-row :gutter="15">
          <a-list :grid="{ gutter: 16, column: 4 }">
            <a-list-item
              :key="index"
              v-for="(item, index) in resultFilePathData"
              @dblclick="getTestResultFileListData(item.id)"
            >
              <img
                style="cursor: pointer"
                src="../../assets/imgs/file.png"
                width="100"
              />
              <div :title="item.name" class="pname">{{ item.name }}</div>
            </a-list-item>
          </a-list>
        </a-row>
      </div>
    </a-card>
  </div>
</template>

<script>
// 演示如何使用 this.$dialog 封装 modal 组件
// import TaskForm from './modules/TaskForm'
import Info from "@components/info";
import * as projectManagement from "@api/projectManage";
import * as task from "@api/task_management";
import * as test from "@api/test_file";
import TrainConfig from "./TrainConfig";
import TrainConfig_classify from "./TrainConfig_classify";
import * as networkmodel from "@api/networkmodel_management";
import * as networkmodeltype from "@api/networkmodeltype_management";
import * as labelFile from "@api/label_file";
import TaskForm from "./TaskForm";
import axios from "axios";
import { requestUrl } from "@utils/request_url";
import request from "@utils/request";
import TrainLog from "./TrainLog";
import CommentHeader from "@components/header";
import AddTask from "./AddTask";
import EditTask from "./EditTask";
import Check from "./Check.vue";

const data = [];
const columns = [
  {
    title: "项目名称",
    width: 200,
    dataIndex: "projectName",
    key: "projectName",
  },
  {
    title: "算法类型",
    width: 200,
    dataIndex: "networkModelName",
    key: "networkModelName",
  },
  {
    title: "资源库（测试）",
    width: 300,
    dataIndex: "resourceName",
    key: "resourceName",
  },
  {
    title: "状态",
    width: 100,
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
    align: "center",
  },
  {
    title: "提交时间",
    width: 200,
    dataIndex: "submitTime",
    key: "submitTime",
    align: "center",
  },
  {
    title: "进度",
    width: 300,
    dataIndex: "progress",
    key: "progress",
    align: "center",
    scopedSlots: { customRender: "progress" },
  },
  {
    title: "测试操作",
    width: 100,
    dataIndex: "action",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" },
  },
  {
    title: "操作",
    width: 100,
    dataIndex: "actions",
    key: "actions",
    align: "center",
    scopedSlots: { customRender: "actions" },
  },
];
const innerColumns = [
  {
    title: "资源名称(训练)",
    dataIndex: "resourceNames",
    key: "resourceNames",
    align: "center",
  },
  {
    title: "训练开始时间",
    dataIndex: "startTime",
    key: "startTime",
    align: "center",
  },
  {
    title: "训练完成时间",
    dataIndex: "completeTime",
    key: "completeTime",
    align: "center",
  },
];
export default {
  name: "TaskManagement",
  components: {
    CommentHeader,
    Info,
    TrainConfig,
    TrainConfig_classify,
    TaskForm,
    TrainLog,
    AddTask,
    EditTask,
    Check,
  },
  data() {
    return {
      visibleFlag: 1, //1 list 2 result
      // editModel:null,
      checkVisible: false,
      innerColumns,
      TaskStatics: null,
      editId: 0,
      edittaskdata: [],
      editdata: {},
      showEditTask: false,
      addpagination: {},
      addtaskData: {},
      showAddTask: false,
      networkModelList: [],
      networkModelTypeList: [],
      resourceList: [],
      projectList: [],
      taskStatics: {
        awaitCount: "0个",
        prepCount: "0个",
        traningCount: "0个",
        completeCount: "0个",
      },
      queryParam: {
        status: "-1",
        projectId: "0",
      },
      queryParam1: {
        status: "-1",
        projectId: "0",
      },
      paging: {
        pageSize: 10,
        totalRecords: 1,
        pageIndex: 1,
      },
      data,
      columns,
      visible: false,
      confirmLoading: false,
      mdl: null,
      title: "",
      visible1: false,
      confirmLoading1: false,
      mdl1: null,
      title1: "",
      currentTaskId: 0,
      isConfig: false,
      currentConfigId: 0,
      updateStatusProgressTime: null,
      getTrainLogTime: null,
      getdefaultLogTime: null,
      visible2: false,
      confirmLoading2: false,
      mdl2: null,
      title2: "实时训练记录",
      logId1: 0,
      logId2: 0,
      logData: [],
      showAlertMsg: true,
      showNetworkModelType: true,
      fathertitle: "测试管理",
      childtitle: "任务管理(测试)",
      path: "/train/project-list",
      isopenvalue: false,
      testList: [],
      testFileList: [],
      testType: false,
      count: 0,
      id: "",
      current: 1,
      testResultVisible: false,
      testResultWidth: 1400,
      testTaskId: 0,
      pathId: 0,
      testResultSearchFileName: "",
      showType: 1,
      isShowDivisionParams: true,
      resultPagition: {
        totalRecords: 0,
        totalPages: 0,
        pageIndex: 1,
        pageSize: 8,
        currentRecordIndex: 0,
      },
      resultFilePathData: [],
      resultFileData: [],
      searchFileName: "",
      divisionParams: {
        area: 0,
        width: 0,
        height: 0,
        gray: 0,
      },
      imgText: "",
      listImages: [], //列表图片集,
      listLoading: false,
      borderColor: 0,
      image: null,
      imgOffsetLeft: 0,
      imgOffsetTop: 0,
      tempWidth: 0,
      tempHeight: 0,
      imgUrl: "",
      canvas: null,
      ctx: null,
      pathId: 0,
      scaleNumber: 1,
      imgLoading: false,
      resultType: 1, //1无二级目录 2:有二级目录
      delFlag: false,
      upFlag: false,
      downFlag: false,
      searchPage: 0,
      // 搜索框 发生改变标识
      searchInputPageFlag: false,
    };
  },
  methods: {
    //加载图片完毕后修改图片的宽高
    imgLoad(i) {
      const LIST = this.$refs.minimg;
      const width = LIST[i].width;
      const height = LIST[i].height;
      console.log(`LIST[${i}]`, width, height);
      const scale = width / height;
      if (width > height) {
        if (width > 90) {
          if (90 / scale > 90) {
            LIST[i].style.height = "90px";
            LIST[i].style.width = `${scale * 90}px`;
          } else {
            LIST[i].style.width = "90px";
            LIST[i].style.height = `${90 / scale}px`;
          }
        } else {
          if (LIST[i].height > 90) {
            LIST[i].style.height = "90px";
            LIST[i].style.width = `${scale * 90}px`;
          }
        }
      } else {
        if (LIST[i].height > 90) {
          LIST[i].style.height = "90px";
          LIST[i].style.width = `${scale * 90}px`;
        }
      }
    },
    projectFilterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    buildFilePath(item) {
      if (
        item != null &&
        item.thumbFileUrl != null &&
        item.thumbFileUrl.length > 0
      ) {
        let fileName = item.thumbFileUrl.replace(/#/g, "%23");
        var image = new Image();
        return requestUrl + "/train/" + fileName;
      }
      return "";
    },

    // 更改current
    currentChange(e) {
      this.current = e;
    },
    // 双击点击文件夹
    changee(e) {
      this.testList = this.photoSize(e.list);
      this.count = e.totalRecords;
    },
    // id变化
    idChange(e) {
      this.id = e;
    },
    // 控制显示隐藏
    testTypeChange(e) {
      // console.log(e);
      this.testType = e;
    },
    // 页码分页变化
    testListChange(e) {
      this.testList = this.photoSize(e.list);
      this.count = e.totalRecords;
    },

    lookTestResult(record) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve();
        }, 500);
      }).then((r) => {
        console.log(record);
        this.visibleFlag = 2;
        clearInterval(this.updateStatusProgressTime);
        this.testTaskId = record.id;
        this.testResultSearchFileName = "";
        const that = this;
        test.getTestTypeApi({ taskId: record.id }).then((res) => {
          if (res.data == 1) {
            //文件列表
            that.resultType = 1;
            test.getTestIdApi({ taskId: that.testTaskId }).then((res2) => {
              that.pathId = res2.data[0].id;
              that.loadFileListData();
            });
          } else {
            //文件夹
            that.resultType = 2;
            that.loadTestResultFilePathData(record.id);
          }
        });
      });
    },
    testResultCancel() {
      this.$refs.testResult.clearData();
      this.testResultVisible = false;
    },
    testResultPathClick(pathId) {
      const that = this;
    },
    testResultPathBck() {
      const that = this;
      test.getTestTypeApi({ taskId: that.testTaskId }).then((res) => {
        that.showType = res.data;
        if (res.data == 1) {
          //文件列表
          test.getTestIdApi({ taskId: that.testTaskId }).then((res2) => {
            that.pathId = res2.data[0].id;
            test.getNetworkModel({ taskId: that.testTaskId }).then((res3) => {
              if (res3.data == 19 || res3.data == 27) {
                that.isShowDivisionParams = true;
              } else {
                that.isShowDivisionParams = false;
              }
              that.$nextTick(() => {
                that.$refs.testResult.refreshData();
                that.testResultVisible = true;
              });
            });
          });
        } else {
          //文件夹
          that.$nextTick(() => {
            that.$refs.testResult.refreshData();
            that.testResultVisible = true;
          });
        }
      });
    },
    errorMsg(msg) {
      test.getError(msg.id).then((res) => {
        console.log(res);
        this.$error({
          title: "错误信息提示",
          content: `${res.data}`,
        });
      });
    },

    buildInnerText(record) {
      var arr = [];
      arr.push(record.trainTaskDetailBo);
      return arr;
    },
    edittask(value) {
      const that = this;
      console.log(value);
      test
        .editTestTask({
          id: value.id,
          fileHeight: value.imageHeight,
          fileWidth: value.imageWidth,
          testFilePathIds: value.pathIds,
          keepRatio: value.keepRatio,
        })
        .then((res) => {
          that.$message.success("更新成功");
          that.loadTask();
        });
      this.showEditTask = false;
    },
    canceledit() {
      this.showEditTask = false;
    },
    onClose(e) {
      console.log(e, "I was closed.");
    },
    handleCancel() {
      if (
        this.$refs.trainConfig != undefined ||
        this.$refs.trainConfig.form != undefined
      ) {
        this.$refs.trainConfig.form.resetFields();
      }
      this.visible = false;
    },
    addtask(obj) {
      const form = this.$refs.addtask.form;
      const iskeepRatio = this.$refs.addtask.iskeepRatio;
      // console.log(iskeepRatio);
      var arr = [];
      const that = this;
      form.validateFields((errors, values) => {
        if (!errors) {
          // console.log(values);
          values.pathIds.forEach((item) => {
            var obj1 = obj.resource.filter((val) => {
              return val.name == item;
            });
            arr.push(obj1[0].id);
            // console.log(arr);
            // 向后端传递参数

            // test.addTestTask({})
          });
          test
            .addTestTask({
              projectId: obj.projectId,
              trainTaskId: obj.model.taskId,
              fileWidth: values.imageWidth,
              fileHeight: values.imageHeight,
              keepRatio: iskeepRatio,
              testFilePathIds: arr,
            })
            .then((res) => {
              console.log(res);
              this.loadTask();
            });
          // console.log(arr);
          this.showAddTask = false;
          this.$refs.addtask.form.resetFields();
        } else {
          console.log(errors);
        }
      });
      this.queryParam1 = {
        status: "-1",
        projectId: "0",
      };
    },
    cancelAdd(value) {
      this.showAddTask = value;
      this.$refs.addtask.form.resetFields();
      this.queryParam1 = {
        status: "-1",
        projectId: "0",
      };
    },
    handleOk() {
      const form = this.$refs.trainConfig.form;
      const self = this;
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log("values", values);
          new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          }).then((res) => {
            if (self.isConfig) {
              // 新增
              task
                .updateConfig({
                  ...values,
                  taskId: this.currentTaskId,
                  id: self.currentConfigId,
                })
                .then((r) => {
                  self.visible = false;
                  self.confirmLoading = false;
                  form.resetFields();
                  self.$message.success("训练参数配置更新成功");
                });
            } else {
              task
                .addConfig({ ...values, taskId: this.currentTaskId })
                .then((r) => {
                  self.visible = false;
                  self.confirmLoading = false;
                  form.resetFields();
                  self.$message.success("训练参数配置成功");
                });
            }
            setTimeout(() => {
              self.loadTask();
            }, 500);
          });
        } else {
          this.confirmLoading = false;
        }
      });
    },
    handleCancel1() {
      this.visible1 = false;
      if (
        this.$refs.taskForm !== undefined ||
        this.$refs.taskForm.form != undefined
      ) {
        this.$refs.taskForm.form.resetFields();
      }
    },
    handleOk1() {
      const form = this.$refs.taskForm.form;
      this.confirmLoading1 = true;
      const self = this;
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log("values", values);
          if (self.currentTaskId > 0) {
            // 修改 e.g.
            new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            }).then((res) => {
              task._update({ ...values, id: self.currentTaskId }).then((r) => {
                self.visible1 = false;
                self.confirmLoading1 = false;
                form.resetFields();
                self.loadTask();
                self.$message.info("更新任务成功");
              });
            });
          } else {
            // 新增
            new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            }).then((res) => {
              task._add({ ...values }).then((r) => {
                self.visible1 = false;
                self.confirmLoading1 = false;
                form.resetFields();
                self.loadTask();
                this.$message.info("创建成功");
              });
            });
          }
        } else {
          this.confirmLoading1 = false;
        }
      });
    },
    handleCancel2(value) {
      this.visible2 = false;
      this.isopenvalue = value;
      clearInterval(this.getTrainLogTime);
      clearInterval(this.getdefaultLogTime);
    },
    handleOk2() {
      this.visible2 = false;
    },
    add() {
      const self = this;
      this.queryParam.status = 3;
      task
        .getPage({
          ...self.queryParam,
          pageIndex: self.paging.pageIndex,
          pageSize: self.paging.pageSize,
        })
        .then((res) => {
          self.addtaskData = res.data;
          self.addpagination = {
            total: res.data.totalRecords,
            pageSize: 15,
            current: 0,
          };
          self.showAddTask = true;
        });
    },
    changeAddpage(currentpage) {
      const self = this;
      this.queryParam.status = 3;
      task
        .getPage({
          ...self.queryParam,
          pageIndex: currentpage,
          pageSize: self.paging.pageSize,
        })
        .then((res) => {
          self.addtaskData = res.data;
          self.addpagination = {
            total: res.data.totalRecords,
            pageSize: 15,
            current: currentpage,
          };
        });
    },
    start(record) {
      const self = this;
      if (record.status === 1 || record.status === 4) {
        this.$message.warning("当前任务状态不可执行开始测试操作");
      } else {
        this.$confirm({
          title: `你想要开始执行测试吗?`,
          content: `当你点击确认按钮时, 这个对话框将会在执行成功后关闭`,
          okText: "确定",
          cancelText: "取消",
          onOk() {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            })
              .then((res) => {
                test.startTesting({ id: record.id }).then((r) => {
                  self.loadTask();
                });
              })
              .catch(() => console.log("小猪，出错啦，休息会吧!"));
          },
          autoFocusButton: null,
        });
      }
    },
    edit(record) {
      // this.loadConfig(record.id).then((res) => {
      //   console.log(res);
      //   this.editdata = res.data
      // })
      console.log(record);
      this.editId = record.id;
      this.loadResourceList(record.projectId).then((res) => {
        console.log(res);
        this.edittaskdata = res.data;
      });

      this.showEditTask = true;
    },
    remove(record) {
      const self = this;
      this.$confirm({
        title: `你想要删除此任务吗?`,
        content: `当你点击确认按钮时, 这个对话框将会在删除成功时关闭`,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          })
            .then((res) => {
              test.remove({ id: record.id }).then((r) => {
                self.loadTask();
              });
            })
            .catch(() => console.log("小猪，出错啦，休息会吧!"));
        },
        autoFocusButton: null,
      });
    },
    loadProjecList() {
      const self = this;
      projectManagement.getAllProject().then((r) => {
        this.projectList = [];
        for (let index = 0; index < r.data.length; index++) {
          const element = r.data[index];
          self.projectList.push({ id: element.id + "", name: element.name });
        }
      });
    },

    loadTask() {
      const self = this;
      test
        .getPage({
          ...self.queryParam1,
          pageIndex: self.paging.pageIndex,
          pageSize: self.paging.pageSize,
        })
        .then((res) => {
          self.data = [];
          if (
            res.data !== undefined &&
            res.data != null &&
            res.data.list.length > 0
          ) {
            self.paging.totalRecords = res.data.totalRecords;
            for (let index = 0; index < res.data.list.length; index++) {
              const element = res.data.list[index];
              self.data.push({
                id: element.id,
                key: element.id,
                projectId: element.projectId,
                networkModelName:
                  element.networkModel == null
                    ? "无"
                    : element.networkModel.name,
                //  networkModelName: element.networkModel.name,
                networkModelTypeName: element.networkModelTypeName,
                trainTaskDetailBo: element.trainTaskDetailBo,
                networkModel:
                  element.networkModelName +
                  "                         " +
                  element.networkModelTypeName,
                projectName: element.projectName,
                submitTime: element.submitTime,
                resourceName: element.resourceName,
                progress: {
                  status: "exception",
                  value: element.trainProgress,
                },
                status: element.status,
                keepRatio: element.keepRatio,
              });
            }
          } else {
            self.paging.totalRecords = 0;
            self.paging.pageIndex = 1;
          }
        });
    },
    loadTask2(status) {
      this.queryParam1.status = status;
      this.loadTask();
    },
    selectProject(value) {
      this.queryParam.projectId = value;
      this.loadTask();
    },
    selectTestProject(value) {
      this.queryParam1.projectId = value;
      const self = this;
      this.queryParam1.status = 3;
      task
        .getPage({
          ...self.queryParam1,
          pageIndex: self.paging.pageIndex,
          pageSize: self.paging.pageSize,
        })
        .then((res) => {
          console.log(res);
          self.addtaskData = res.data;
          self.addpagination = {
            total: res.data.totalPages,
            pageSize: 15,
            current: 0,
          };
          // self.showAddTask = true
        });
    },
    loadNetworkModelTypeList() {
      const self = this;
      networkmodeltype.getAll().then((res) => {
        self.networkModelTypeList = res.data;
      });
    },

    async loadResourceList(id) {
      const resultData = [];
      const dataUrl =
        requestUrl + "/train/rest/test_file/get_test_resource_list/" + id;
      try {
        const res = await request({
          url: dataUrl,
          method: "get",
        });

        return res;
      } catch (err) {
        console.log(err);
      }
      return resultData;
    },
    async loadConfig(id) {
      const resultData = null;
      const dataUrl = requestUrl + "/train/rest/task/get_task_config/" + id;
      try {
        const res = await request({
          url: dataUrl,
          method: "get",
        });

        return res;
      } catch (err) {
        console.log(err);
      }
      return resultData;
    },

    async loadxx(id) {
      const rr = await this.loadResourceList(id);
      return rr;
    },
    // 测试更新状态
    updateStatusProgress() {
      var ids = [];
      const self = this;
      if (this.data != null && this.data.length > 0) {
        ids = this.data.map((item) => {
          return item.id;
        });
        test.getListStatus(ids).then((r) => {
          for (let index = 0; index < r.data.length; index++) {
            const element = r.data[index];
            self._updateStatusProgress(
              self.data,
              element.id,
              element.status,
              element.testProgress
            );
          }
        });
      }
    },
    _updateStatusProgress(data, id, status, progress) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (element.id === id) {
          if (element.status !== status) element.status = status;
          element.progress.value = progress;
        }
      }
    },
    openLog(item) {
      this.currentTaskId = item.id;
      this.logId1 = 0;
      this.logId2 = 0;
      const self = this;
      this.visible2 = true;
      this.logData = [];
      clearInterval(this.getTrainLogTime);
      clearInterval(this.getdefaultLogTime);
      if (this.isopenvalue == false) {
        // this.logData = [];
        this.getdefaultLogTime = setInterval(() => {
          self.getdefaultlog(self);
        }, 1000);
      } else {
        this.getTrainLogTime = setInterval(() => {
          self.getLog(self);
        }, 1000);
      }
    },
    getLog(self) {
      console.log(self.currentTaskId);
      task
        .getTrainLog({ taskId: self.currentTaskId, logId: self.logId2 })
        .then((r) => {
          var flag = false;
          if (r.data != null) {
            // self.logId2 = r.data.id;
            if (self.isopenvalue == true) {
              self.logData.push(r.data);
            }
          } else {
            return;
          }
        });
    },
    getdefaultlog(self) {
      task
        .defaultgetTrainLog({ taskId: self.currentTaskId, logId: self.logId1 })
        .then((r) => {
          var flag = false;
          if (r.data != null) {
            // self.logId1 = r.data.id;
            if (self.isopenvalue == false) {
              self.logData = r.data;
            } else {
              self.logData = [];
            }
          } else {
            return;
          }
        });
    },
    isopen(value) {
      this.isopenvalue = value;
      const self = this;
      clearInterval(this.getTrainLogTime);
      clearInterval(this.getdefaultLogTime);
      if (this.isopenvalue == false) {
        this.logData = [];
        this.getdefaultLogTime = setInterval(() => {
          self.getdefaultlog(self);
        }, 1000);
      } else {
        // this.logId2 = 0
        this.logData = [];
        this.getTrainLogTime = setInterval(() => {
          self.getLog(self);
        }, 1000);
      }
    },
    downloadTrainModel(record) {
      const userid = localStorage.getItem("user_id");
      // console.log(userid);
      if (userid == "1e18f0a07b6647a692c8a9a4b29dd875") {
        window.location.href =
          requestUrl +
          "/train/rest/file/download_train_model_onnx/" +
          record.id;
      } else {
        window.location.href =
          requestUrl + "/train/rest/file/download_train_model/" + record.id;
      }
    },
    onChangepage(page, pageSize) {
      this.paging.pageIndex = page;
      this.loadTask();
      clearInterval(this.updateStatusProgressTime);
      this.updateStatusProgressTime = setInterval(
        this.updateStatusProgress,
        1000
      );
    },

    loadFileListData() {
      (this.imgUrl = ""), (this.imgText = "");
      this.getTestResultFileListData(this.pathId);
    },
    getTestResultFileListData(pathId) {
      this.pathId = pathId;
      this.showType = 1;
      this.canvas = null;
      this.ctx = null;
      this.listLoading = true;
      this.canvas = document.getElementById("mycanvas");
      const that = this;
      // if (this.canvas != null) this.ctx = this.canvas.getConetxt("2d");
      document.onkeydown = function (event) {
        if (!that.searchInputPageFlag) {
          let key = window.event.keyCode;
          console.log(key);
          if (key === 38) {
            //上
            that.keyBoardUp();
          }
          if (key === 40) {
            //下
            that.keyBoardDown();
          }
          if (key === 68) {
            that.download();
          }
        }
      };
      let cIndex = 0;
      test
        .getTestListApi({
          pageIndex: that.resultPagition.pageIndex,
          pageSize: that.resultPagition.pageSize,
          pathId: pathId,
          fileName: that.searchFileName,
        })
        .then((res) => {
          that.resultFileData = [];
          var datalist = res.data.list;
          that.resultPagition.totalPages = res.data.totalPages;
          that.resultPagition.totalRecords = res.data.totalRecords;
          debugger;
          if (that.borderColor == 0) cIndex = 1;
          else cIndex = that.borderColor + 1;
          that.resultPagition.currentRecordIndex =
            (that.resultPagition.pageIndex - 1) * that.resultPagition.pageSize +
            cIndex;
          datalist.forEach((element) => {
            that.resultFileData.push(element);
          });

          if (that.resultFileData.length > 0) {
            that.imgText = that.resultFileData[0].fileName;
            if (that.resultFileData[0].area != null)
              that.divisionParams.area = that.resultFileData[0].area;
            else that.divisionParams.area = 0;
            if (that.resultFileData[0].width != null)
              that.divisionParams.width = that.resultFileData[0].width;
            else that.divisionParams.width = 0;
            if (that.resultFileData[0].height != null)
              that.divisionParams.height = that.resultFileData[0].height;
            else that.divisionParams.height = 0;
            if (that.resultFileData[0].gray != null)
              that.divisionParams.gray = that.resultFileData[0].gray;
            else that.divisionParams.gray = 0;
            that.$nextTick(() => {
              that.initListImages();
            });
          } else {
            that.imgText = "暂无";
            that.listLoading = false;
          }
        });
    },

    fixCanvas() {
      this.imgOffsetLeft = this.image.offsetLeft;
      this.imgOffsetTop = this.image.offsetTop;
      if (this.canvas != null) {
        this.canvas.style.left = this.imgOffsetLeft + "px";
        this.canvas.style.top = this.imgOffsetTop + "px";
        this.canvas.width = parseInt(this.image.style.width);
        this.canvas.height = parseInt(this.image.style.height);
      }
      this.imgLoading = false;
    },
    //初始化列表
    initListImages() {
      const that = this;

      // this.listImages = this.$refs.minimg;

      // for (let i = 0; i < this.listImages.length; i++) {

      //   that.listImages[i].onload = function () {

      //   };

      // }
      that.listLoading = false;
      that.initImage();
    },

    loadTestResultFilePathData(taskId) {
      const that = this;
      //  that.listLoading = true;
      this.resultFilePathData = [];
      test.getTestRestPathListApi({ taskId: taskId }).then((res) => {
        that.resultFilePathData = res.data;
        that.showType = 2;
      });
    },
    initImage() {
      // this.imgLoading = true;
      this.image = this.$refs.img;
      const that = this;
      if (this.resultFileData.length > 0) {
        this.imgUrl =
          requestUrl +
          "/train/" +
          this.resultFileData[that.borderColor].fileUrl;
        this.$refs.img.onload = function () {
          const width = that.resultFileData[that.borderColor].width;
          const height = that.resultFileData[that.borderColor].height;

          const scale = that.image.width / that.height;
          if (that.image.width > that.image.height) {
            if (that.image.width > 1350) {
              if (1350 / scale > 550) {
                that.image.style.height = "550px";
                that.image.style.width = `${scale * 550}px`;
              } else {
                that.image.style.width = "1350px";
                that.image.style.height = `${1350 / scale}px`;
              }
            } else {
              if (that.image.height > 550) {
                that.image.style.height = "550px";
                that.image.style.width = `${scale * 550}px`;
              } else {
                that.image.style.height = that.image.height + "px";
                that.image.style.width = that.image.width + "px";
              }
            }
          } else {
            if (that.image.height > 550) {
              that.image.style.height = "550px";
              that.image.style.width = `${scale * 550}px`;
            } else {
              that.image.style.height = that.image.height + "px";
              that.image.style.width = that.image.width + "px";
            }
          }
          that.tempWidth = width / parseInt(that.image.style.width);
          that.tempHeight = height / parseInt(that.image.style.height);
          that.fixCanvas();
        };
      }
    },

    toUp() {
      if (this.resultPagition.pageIndex <= 1) {
        this.$message.warning("图片列表到顶了");
        this.upFlag = true;
      } else {
        this.upFlag = false;
        this.resultPagition.pageIndex--;
        this.searchPage = this.resultPagition.pageIndex;
        this.borderColor = 0;
        this.loadFileListData();
      }
    },
    toNext() {
      if (this.resultPagition.pageIndex >= this.resultPagition.totalPages) {
        this.$message.warning("图片列表到底了");
        this.downFlag = true;
      } else {
        this.downFlag = false;
        this.resultPagition.pageIndex++;
        this.searchPage = this.resultPagition.pageIndex;
        this.borderColor = 0;
        this.loadFileListData();
      }
    },
    // 当前页发生改变
    currentPageChange(val) {
      if (val) {
        if (val > this.resultPagition.totalPages) {
          this.$message.warning("超过图片列表总页数啦");
          return;
        }
        this.resultPagition.pageIndex = val;
        this.searchInputPageFlag = true;
        this.loadFileListData();
      }
    },

    handlerImg(item, index) {
      this.downFlag = false;
      this.upFlag = false;
      this.searchInputPageFlag = false;
      const that = this;
      this.imgLoading = true;
      this.borderColor = index;
      this.imgText = item.fileName;
      this.imgUrl = requestUrl + "/train/" + item.fileUrl.replace(/#/g, "%23");
      this.$refs.img.onload = function () {
        const width = that.resultFileData[that.borderColor].width;
        const height = that.resultFileData[that.borderColor].height;

        const scale = that.image.width / that.height;
        if (that.image.width > that.image.height) {
          if (that.image.width > 1350) {
            if (1350 / scale > 550) {
              that.image.style.height = "550px";
              that.image.style.width = `${scale * 550}px`;
            } else {
              that.image.style.width = "1350px";
              that.image.style.height = `${1350 / scale}px`;
            }
          } else {
            if (that.image.height > 550) {
              that.image.style.height = "550px";
              that.image.style.width = `${scale * 550}px`;
            } else {
              that.image.style.height = that.image.height + "px";
              that.image.style.width = that.image.width + "px";
            }
          }
        } else {
          if (that.image.height > 550) {
            that.image.style.height = "550px";
            that.image.style.width = `${scale * 550}px`;
          } else {
            that.image.style.height = that.image.height + "px";
            that.image.style.width = that.image.width + "px";
          }
        }
        that.tempWidth = width / parseInt(that.image.style.width);
        that.tempHeight = height / parseInt(that.image.style.height);
        that.fixCanvas();
      };
      this.imgLoading = false;
      // this.fileId = item.id;
      if (item.area != null) this.divisionParams.area = item.area;
      else this.divisionParams.area = 0;
      if (item.width != null) this.divisionParams.width = item.width;
      else this.divisionParams.width = 0;
      if (item.heigth != null) this.divisionParams.height = item.height;
      else this.divisionParams.height = 0;
      if (item.gray != null) this.divisionParams.gray = item.gray;
      else this.divisionParams.gray = 0;
      this.resultPagition.currentRecordIndex =
        (this.resultPagition.pageIndex - 1) * this.resultPagition.pageSize +
        index +
        1;
    },

    keyBoardUp() {
      const that = this;
      if (this.borderColor <= 0) this.toUp();
      else {
        this.borderColor--;
      }
      if (this.upFlag) {
        return;
      }
      this.imgLoading = true;
      var currentFileData = this.resultFileData[this.borderColor];
      this.imgText = currentFileData.fileName;
      this.imgUrl =
        requestUrl + "/train/" + currentFileData.fileUrl.replace(/#/g, "%23");
      this.fileId = currentFileData.id;
      this.$refs.img.onload = function () {
        const width = that.resultFileData[that.borderColor].width;
        const height = that.resultFileData[that.borderColor].height;

        const scale = that.image.width / that.height;
        if (that.image.width > that.image.height) {
          if (that.image.width > 1350) {
            if (1350 / scale > 550) {
              that.image.style.height = "550px";
              that.image.style.width = `${scale * 550}px`;
            } else {
              that.image.style.width = "1350px";
              that.image.style.height = `${1350 / scale}px`;
            }
          } else {
            if (that.image.height > 550) {
              that.image.style.height = "550px";
              that.image.style.width = `${scale * 550}px`;
            } else {
              that.image.style.height = that.image.height + "px";
              that.image.style.width = that.image.width + "px";
            }
          }
        } else {
          if (that.image.height > 550) {
            that.image.style.height = "550px";
            that.image.style.width = `${scale * 550}px`;
          } else {
            that.image.style.height = that.image.height + "px";
            that.image.style.width = that.image.width + "px";
          }
        }
        that.tempWidth = width / parseInt(that.image.style.width);
        that.tempHeight = height / parseInt(that.image.style.height);
        that.fixCanvas();
      };
      if (currentFileData.area != null)
        this.divisionParams.area = currentFileData.area;
      else this.divisionParams.area = 0;
      if (currentFileData.width != null)
        this.divisionParams.width = currentFileData.width;
      else this.divisionParams.width = 0;
      if (currentFileData.heigth != null)
        this.divisionParams.height = currentFileData.height;
      else this.divisionParams.height = 0;
      if (currentFileData.gray != null)
        this.divisionParams.gray = currentFileData.gray;
      else this.divisionParams.gray = 0;
      this.resultPagition.currentRecordIndex =
        (this.resultPagition.pageIndex - 1) * this.resultPagition.pageSize +
        this.borderColor +
        1;
    },
    keyBoardDown() {
      const that = this;
      if (this.borderColor >= 7) this.toNext();
      else {
        if (
          this.resultPagition.totalRecords >
          this.resultPagition.currentRecordIndex
        )
          this.borderColor++;
      }
      if (this.downFlag) {
        return;
      }
      this.imgLoading = true;
      var currentFileData = this.resultFileData[this.borderColor];
      this.imgText = currentFileData.fileName;
      this.imgUrl =
        requestUrl + "/train/" + currentFileData.fileUrl.replace(/#/g, "%23");

      this.fileId = currentFileData.id;
      this.$refs.img.onload = function () {
        const width = that.resultFileData[that.borderColor].width;
        const height = that.resultFileData[that.borderColor].height;

        const scale = that.image.width / that.height;
        if (that.image.width > that.image.height) {
          if (that.image.width > 1350) {
            if (1350 / scale > 550) {
              that.image.style.height = "550px";
              that.image.style.width = `${scale * 550}px`;
            } else {
              that.image.style.width = "1350px";
              that.image.style.height = `${1350 / scale}px`;
            }
          } else {
            if (that.image.height > 550) {
              that.image.style.height = "550px";
              that.image.style.width = `${scale * 550}px`;
            } else {
              that.image.style.height = that.image.height + "px";
              that.image.style.width = that.image.width + "px";
            }
          }
        } else {
          if (that.image.height > 550) {
            that.image.style.height = "550px";
            that.image.style.width = `${scale * 550}px`;
          } else {
            that.image.style.height = that.image.height + "px";
            that.image.style.width = that.image.width + "px";
          }
        }
        that.tempWidth = width / parseInt(that.image.style.width);
        that.tempHeight = height / parseInt(that.image.style.height);
        that.fixCanvas();
      };
      if (currentFileData.area != null)
        this.divisionParams.area = currentFileData.area;
      else this.divisionParams.area = 0;
      if (currentFileData.width != null)
        this.divisionParams.width = currentFileData.width;
      else this.divisionParams.width = 0;
      if (currentFileData.heigth != null)
        this.divisionParams.height = currentFileData.height;
      else this.divisionParams.height = 0;
      if (currentFileData.gray != null)
        this.divisionParams.gray = currentFileData.gray;
      else this.divisionParams.gray = 0;
      this.resultPagition.currentRecordIndex =
        (this.resultPagition.pageIndex - 1) * this.resultPagition.pageSize +
        this.borderColor +
        1;
    },

    download() {
      if (this.imgUrl != "") {
        const that = this;
        var currentFileData = this.resultFileData[this.borderColor];
        test
          .getSourceTestFile({
            taskId: currentFileData.taskId,
            fileId: currentFileData.id,
          })
          .then((res) => {
            var fileList = res.data;
            if (fileList.length > 0) {
              var fileIds = [];
              for (var i = 0; i < res.data.length; i++) {
                fileIds.push({ id: res.data[i].id });
              }
              if (that.delFlag) {
                test.removeTestFiles(fileIds).then((res) => {});
              }
              var fileUrl =
                requestUrl +
                "/train" +
                fileList[0].fileUrl +
                "?t=" +
                new Date().getTime();
              var fileName = fileList[0].fileName;
              fetch(fileUrl).then((res) => {
                res.blob().then((myBlob) => {
                  const href = URL.createObjectURL(myBlob);
                  const a = document.createElement("a");
                  a.href = href;
                  a.download = fileName;
                  a.click();
                  a.remove();
                });
              });
            }
          });
      }
    },
    download2() {
      if (this.imgUrl != "") {
        var currentFileData = this.resultFileData[this.borderColor];
        let image = new Image();
        image.setAttribute("crossOrigin", "anonymous");
        image.src = this.imgUrl + "?t=" + new Date().getTime();
        image.onload = () => {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(image, 0, 0, image.width, image.height);
          canvas.toBlob((blob) => {
            let url = URL.createObjectURL(blob);
            this._download(url, currentFileData.fileName);
            // 用完释放URL对象
            URL.revokeObjectURL(url);
          });
        };
      }
    },
    _download(href, name) {
      let eleLink = document.createElement("a");
      eleLink.download = name;
      eleLink.href = href;
      eleLink.click();
      eleLink.remove();
    },
    canvasDown(e) {
      const that = this;
      const box = document.getElementById("tagInBox");
      const bigbox = document.getElementById("bigbox");
      var distanceX = e.clientX - box.offsetLeft;
      var distanceY = e.clientY - box.offsetTop;
      box.onmousemove = function (ev) {
        var oevent = ev;
        box.style.left = oevent.clientX - distanceX + "px";
        box.style.top = oevent.clientY - distanceY + "px";
      };
      bigbox.onmouseleave = function () {
        box.onmousemove = null;
      };
      //bigbox 监听鼠标滚轮事件 放大
      bigbox.onmousewheel = function (ev) {
        var oevent = ev;
        if (oevent.wheelDelta > 0) {
          that.scale("zoomIn");
        } else {
          that.scale("zoomOut");
        }
      };
      box.onmouseup = function () {
        box.onmousemove = null;
      };
    },
    canvasMove(e) {
      const canvasPosition = {
        x: e.offsetX,
        y: e.offsetY,
      };
      if (this.mouseDown) {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      }
    },
    canvasUp(e) {
      this.mouseDown = false;
      const canvasPosition = {
        x: e.offsetX,
        y: e.offsetY,
      };
    },

    scale(type) {
      // this.status = 0;
      // this.dotstatus = 0;
      const box = document.getElementById("tagInBox");
      if (type == "zoomIn") {
        this.scaleNumber += 0.2;
        box.style.transform = "scale(" + this.scaleNumber + ")";
      } else {
        this.scaleNumber -= 0.2;
        box.style.transform = "scale(" + this.scaleNumber + ")";
        if (this.scaleNumber < 0) {
          this.scaleNumber = 0;
        }
      }
    },
    search() {
      this.loadFileListData();
    },

    back() {
      if (this.resultType == 2) {
        if (this.showType == 1) {
          this.borderColor = 0;
          this.loadTestResultFilePathData(this.testTaskId);
        } else {
          this.visibleFlag = 1;
          this.$nextTick(() => {
            this.loadTask();
            this.updateStatusProgressTime = setInterval(
              this.updateStatusProgress,
              1000
            );
          });
        }
      } else {
        this.visibleFlag = 1;
        this.$nextTick(() => {
          this.loadTask();
          this.updateStatusProgressTime = setInterval(
            this.updateStatusProgress,
            1000
          );
        });
      }
    },

    // window.location.href = requestUrl + '/train/rest/file/download_train_model/' + record.id
  },
  updata() {
    console.log("1fg");
  },
  mounted() {
    this.loadProjecList();
    this.loadTask();
    // this.loadNetworkModelList()
    this.loadNetworkModelTypeList();
    this.updateStatusProgressTime = setInterval(
      this.updateStatusProgress,
      1000
    );
  },
  beforeDestroy() {
    console.log("销毁定时器");
    clearInterval(this.updateStatusProgressTime);
  },
};
</script>

<style lang="less" scoped>
::-webkit-scrollbar {
  width: 0 !important;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.ant-avatar-lg {
  width: 48px;
  height: 48px;
  line-height: 48px;
}

.list-content-item {
  color: rgba(0, 0, 0, 0.45);
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  margin-left: 40px;

  span {
    line-height: 20px;
  }

  p {
    margin-top: 4px;
    margin-bottom: 0;
    line-height: 22px;
  }
}
</style>


<style lang="scss" scoped>
.maxbox {
  display: flex;
  // flex-direction: column;
  justify-content: space-between;
}

.ant-row-flex {
  width: 1300px !important;
}

#bigbox {
  user-select: none;
  position: relative;
  width: 1380px;
  height: 550px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.5);
  margin: 10px auto;
  // overflow: auto;
  overflow-x: scroll;
  overflow-y: scroll;
}

#tagInBox {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.canvas-img {
  display: block;
}

#mycanvas {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.imgtext {
  width: 800px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 300px;
  flex-wrap: nowrap;
  float: left;
}

.show-page-list {
  width: 150px;
  float: right;
  position: relative;
  height: 50px;
  right: 7px;
  display: flex;
  justify-content: center;
  font-size: 10px;

  flex-direction: column;
}

.minImgs {
  transform: rotate(90deg);
  position: absolute;
  right: -100px;
  top: 400px;
}

.box2 {
  // width: 120px;
  height: 100%;
  margin-right: 20px;
  display: flex;
  flex-direction: column;

  .imgList {
    width: 128px;
    height: 500px;
    overflow-y: auto;
  }
}

.box {
  width: 800px;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px auto 0 auto;

  .imgbox {
    overflow: auto;
    height: 106px;
    position: relative;

    .imgminbox {
      height: 106px;
      left: 0;
      right: 0;
      position: absolute;
      transition: all 0.5s;
    }
  }
}

.changeMinImg {
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.minimgbox {
  width: 100%;
  height: 120px;
  box-sizing: border-box;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 2px solid white;
  padding: 0 5px;

  .ismark {
    position: absolute;
    top: 86px;
    color: red;
  }

  .ismark2 {
    position: absolute;
    top: 100px;
    color: blue;
  }
}

.borderColor {
  border: 2px solid red !important;
  height: 106px;
}

.tools {
  // position: absolute;
  width: 20px;
  height: 490px;
  margin-top: 50px;
  // top: 150px;
  // left: 240px;
  z-index: 4;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-end;

  .toolsbtn {
    width: 100%;
    height: 50px;
  }
}

.taggroup {
  box-shadow: 0 0 8px 2px rgba(70, 68, 68, 0.3);
  // position: absolute;
  width: 200px;
  height: 750px;
  margin-top: 12px;
  // right: 20px;
  // top: 122px;
  overflow-y: auto;

  .tagtitle {
    margin-top: 10px;
    line-height: 32px;

    .tagbutton {
      margin-right: 10px;
      float: right;
    }
  }

  .tagsitem {
    margin-top: 5px;
    line-height: 40px;
    padding: 0 10px;
    cursor: pointer;
    display: flex;
    border: 1px solid rgba(70, 68, 68, 0.137);
    justify-content: space-between;
    align-items: center;
  }

  .tagsitem:hover {
    border: 1px solid rgba(38, 135, 190, 0.5);
  }
}

.addInputbutton {
  cursor: pointer;
}

.addInputbutton:hover {
  color: red;
}

.addtaginput {
  height: 35px;
}

#tagsBox {
  position: absolute;
  z-index: 10;
  left: 10px;
  top: 10px;
  width: 160px;
  background: white;
  height: 100px;
  overflow-y: auto;

  .tagsItemInCanvas {
    margin-top: 5px;
    line-height: 20px;
    padding: 0 10px;
    cursor: pointer;
    display: flex;
    border: 1px solid rgba(70, 68, 68, 0.137);
  }

  .tagsItemInCanvas:hover {
    border: 1px solid rgba(38, 135, 190, 0.5);
  }

  #functionBox {
    position: absolute;
    z-index: 10;
    left: 10px;
    top: 10px;
    width: 160px;
    background: white;
    height: 100px;
    overflow-y: auto;

    .tagsItemInCanvas {
      margin-top: 5px;
      line-height: 20px;
      padding: 0 10px;
      cursor: pointer;
      display: flex;
      border: 1px solid rgba(70, 68, 68, 0.137);
    }

    .tagsItemInCanvas:hover {
      border: 1px solid rgba(38, 135, 190, 0.5);
    }
  }
}
</style>
